(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ax-clearbee-hero"] && !Shopify.designMode) return;
  try {
    

(function () {
  const roots = document.querySelectorAll('[data-ax-clearbee-hero]');

  if (!roots.length) return;

  roots.forEach(function (root) {

    const form = root.querySelector('form.ax-clearbee-hero__form');
    const emailInput = root.querySelector('.ax-clearbee-hero__input');

    const termsCheckbox = root.querySelector('.ax-clearbee-hero__terms-checkbox');
    const termsError = root.querySelector('.ax-clearbee-hero__terms-error');

    if (!form || !emailInput) return;

    form.addEventListener('submit', function (event) {

      if (termsCheckbox && !termsCheckbox.checked) {

        event.preventDefault();

        if (termsError) termsError.hidden = false;

        termsCheckbox.setAttribute(
          'aria-invalid',
          'true'
        );

        termsCheckbox.focus();

        return;
      }

      const email = emailInput.value.trim();

      if (email) {
        sessionStorage.setItem(
          'clearbee_customer_email',
          email
        );
      }

    });

    if (termsCheckbox) {

      termsCheckbox.addEventListener('change', function () {

        if (termsCheckbox.checked) {
          if (termsError) termsError.hidden = true;
          termsCheckbox.removeAttribute('aria-invalid');
        }

      });

    }

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ax-package"] && !Shopify.designMode) return;
  try {
    

(function () {

  const roots = document.querySelectorAll(
    '[data-ax-package]'
  );

  if (!roots.length) return;


  roots.forEach(function (root) {

    const form = root.querySelector(
      'form.ax-reservation-cta__form'
    );

    const emailInput = root.querySelector(
      '.ax-reservation-cta__input'
    );

    const checkbox = root.querySelector(
      '.ax-clearbee-hero__terms-checkbox'
    );

    const termsWrapper = root.querySelector(
      '.ax-clearbee-hero__terms'
    );

    const errorMessage = root.querySelector(
      '.ax-clearbee-hero__terms-error'
    );


    if (!form) return;


    /*
      Email storage
    */

    form.addEventListener('submit', function (event) {

      /*
        AGB validation
      */

      if (checkbox && !checkbox.checked) {

        event.preventDefault();

        if (termsWrapper) {
          termsWrapper.classList.add('has-error');
        }

        if (errorMessage) {
          errorMessage.hidden = false;
        }

        checkbox.focus();

        return;
      }


      /*
        Remove error
      */

      if (termsWrapper) {
        termsWrapper.classList.remove('has-error');
      }

      if (errorMessage) {
        errorMessage.hidden = true;
      }


      /*
        Save customer email
      */

      if (emailInput) {

        const email = emailInput.value.trim();

        if (email) {

          sessionStorage.setItem(
            'clearbee_customer_email',
            email
          );

        }

      }

    });


    /*
      Remove checkbox error immediately
      when customer checks it.
    */

    if (checkbox) {

      checkbox.addEventListener('change', function () {

        if (checkbox.checked) {

          if (termsWrapper) {
            termsWrapper.classList.remove('has-error');
          }

          if (errorMessage) {
            errorMessage.hidden = true;
          }

        }

      });

    }


    /*
      Also remove error when clicking label.
    */

    if (termsWrapper) {

      termsWrapper.addEventListener(
        'click',
        function () {

          if (checkbox && checkbox.checked) {

            termsWrapper.classList.remove(
              'has-error'
            );

            if (errorMessage) {
              errorMessage.hidden = true;
            }

          }

        }
      );

    }

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ax-reservation-cta"] && !Shopify.designMode) return;
  try {
    

(function () {

  const roots = document.querySelectorAll(
    '[data-ax-reservation-cta]'
  );

  if (!roots.length) return;

  roots.forEach(function (root) {

    const form = root.querySelector(
      'form.ax-reservation-cta__form'
    );

    const emailInput = root.querySelector(
      '.ax-reservation-cta__input'
    );

    const termsCheckbox = root.querySelector(
      '.ax-clearbee-hero__terms-checkbox'
    );

    const termsError = root.querySelector(
      '.ax-clearbee-hero__terms-error'
    );

    if (!form || !emailInput) return;


    /* =====================================================
       SAVE EMAIL
       ===================================================== */

    form.addEventListener('submit', function (event) {

      const email = emailInput.value.trim();

      if (email) {

        sessionStorage.setItem(
          'clearbee_customer_email',
          email
        );

      }


      /* ===================================================
         TERMS VALIDATION
         =================================================== */

      if (termsCheckbox && !termsCheckbox.checked) {

        event.preventDefault();

        termsCheckbox.focus();

        if (termsError) {
          termsError.hidden = false;
        }

        return false;
      }

      if (termsError) {
        termsError.hidden = true;
      }

    });


    /* =====================================================
       HIDE ERROR WHEN CHECKBOX IS CLICKED
       ===================================================== */

    if (termsCheckbox) {

      termsCheckbox.addEventListener(
        'change',
        function () {

          if (termsCheckbox.checked && termsError) {

            termsError.hidden = true;

          }

        }
      );

    }

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
